import { ListingAutresFacades } from '@components/listing-autres-facades/models';
import { getCategoryNameFromUrl } from '@mock/schema/components/listing-facades.mock';
import { Block } from '@shared/models';

export const listingAutresFacadesMock: Block<ListingAutresFacades> = {
  type: 'listing-autres-facades',
  data: {
    notCategory: getCategoryNameFromUrl() || 'Mat',
  },
};
